module.exports = __webpack_public_path__ + "static/media/IMG_0291.f6cff3ca.jpg";